import { useState } from 'react';

const SYMBOLS = '!@#$%^&*()_+-=[]{}|;:,.<>?';

function generatePassword() {
  const upper   = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lower   = 'abcdefghijklmnopqrstuvwxyz';
  const digits  = '0123456789';
  const symbols = SYMBOLS;
  const all     = upper + lower + digits + symbols;
  const len     = 20;

  // Garantizar al menos 1 de cada categoría
  let chars = [
    upper[Math.floor(Math.random() * upper.length)],
    lower[Math.floor(Math.random() * lower.length)],
    digits[Math.floor(Math.random() * digits.length)],
    symbols[Math.floor(Math.random() * symbols.length)],
  ];
  for (let i = chars.length; i < len; i++) {
    chars.push(all[Math.floor(Math.random() * all.length)]);
  }
  // Fisher-Yates shuffle
  for (let i = chars.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join('');
}

function getScore(value) {
  if (!value) return { score: 0, criteria: {} };
  const len8   = value.length >= 8;
  const len16  = value.length >= 16;
  const upper  = /[A-Z]/.test(value);
  const number = /[0-9]/.test(value);
  const symbol = new RegExp(`[${SYMBOLS.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')}]`).test(value);
  const score  = [len8, len16, upper, number, symbol].filter(Boolean).length;
  return { score, criteria: { len8, len16, upper, number, symbol } };
}

function getStrength(score) {
  if (score <= 1) return { label: 'Débil',      color: '#ff4d6d', pct: 20  };
  if (score === 2) return { label: 'Media',      color: '#f4a261', pct: 45  };
  if (score === 3) return { label: 'Fuerte',     color: '#00d4ff', pct: 70  };
  return            { label: 'Muy fuerte',  color: '#00e5a0', pct: 100 };
}

export default function PasswordField({ value, onChange, label = 'Contraseña', optional = false }) {
  const [show, setShow] = useState(false);

  const { score, criteria } = getScore(value);
  const strength = getStrength(score);
  const mono = { fontFamily: 'var(--mono)' };

  const criteriaList = [
    { key: 'len8',   label: 'Mín. 8 caracteres'  },
    { key: 'len16',  label: '16+ caracteres'      },
    { key: 'upper',  label: 'Mayúsculas'          },
    { key: 'number', label: 'Números'             },
    { key: 'symbol', label: 'Símbolos'            },
  ];

  return (
    <div style={{ marginBottom: 16 }}>
      <label style={{ display: 'block', fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 8, ...mono }}>
        {label}{optional && <span style={{ color: 'var(--muted)', fontWeight: 400, letterSpacing: 0 }}> (opcional)</span>}
      </label>

      {/* Input row */}
      <div style={{ display: 'flex', border: '1px solid var(--border)', background: 'var(--bg)' }}>
        <input
          type={show ? 'text' : 'password'}
          value={value}
          onChange={e => onChange(e.target.value)}
          style={{ flex: 1, background: 'transparent', border: 'none', color: 'var(--text)', padding: '10px 12px', ...mono, fontSize: 13, outline: 'none', minWidth: 0 }}
        />
        <button
          type="button"
          onClick={() => setShow(s => !s)}
          style={{ background: 'none', border: 'none', borderLeft: '1px solid var(--border)', color: 'var(--muted)', padding: '0 12px', cursor: 'pointer', fontSize: 11, ...mono, whiteSpace: 'nowrap' }}
        >
          {show ? 'OCULTAR' : 'VER'}
        </button>
        <button
          type="button"
          onClick={() => onChange(generatePassword())}
          style={{ background: 'none', border: 'none', borderLeft: '1px solid var(--border)', color: 'var(--accent)', padding: '0 12px', cursor: 'pointer', fontSize: 11, ...mono, fontWeight: 700, whiteSpace: 'nowrap' }}
        >
          GENERAR
        </button>
      </div>

      {/* Strength bar + criteria */}
      {value && (
        <div style={{ marginTop: 8 }}>
          {/* Bar */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
            <div style={{ flex: 1, height: 3, background: 'var(--border)', borderRadius: 2, overflow: 'hidden' }}>
              <div style={{ height: '100%', width: `${strength.pct}%`, background: strength.color, borderRadius: 2, transition: 'width 0.3s ease, background 0.3s ease' }} />
            </div>
            <span style={{ fontSize: 10, ...mono, color: strength.color, minWidth: 60, textAlign: 'right' }}>{strength.label}</span>
          </div>

          {/* Criteria */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 16px' }}>
            {criteriaList.map(({ key, label: cLabel }) => (
              <span key={key} style={{ fontSize: 11, color: criteria[key] ? 'var(--green)' : 'var(--muted)', ...mono }}>
                {criteria[key] ? '✓' : '○'} {cLabel}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
